import React, { useEffect, useMemo, useState, useRef } from "react";
import "./largeAccount.css";
import "./ManageDnd.css";
import { DeleteDND, findDNDList, GetCountries, getCountryCodeList } from "../../../api/Api";
import Swal from "sweetalert2";
import AddDndModal from "./addDndNumber";
import "./settingConf.css";
import { getFromLocalStorage } from "../../../utils/common-utils";
import CustomTable from "../../../components/Table/CustomTable";
import ViewDND from "./viewDND";
import { Navigate } from "react-router-dom";

const ManageDnd = () => {
  const [loaders, setLoaders] = useState({
    countryLoader: false,
  });
  const [pageSize, setPageSize] = useState(10);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dndList, setDndList] = useState([]);
  const [addNumberModal, setAddNumberModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  // const [pageSize] = useState(10);
  const [viewDndModal, setViewDndModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [countryListData, setCountryListData] = useState([]);
  const [tableConfig, setTableConfig] = useState({
    enabledColumns: [],
    actions: [],
  });
  const [mobileCountry, setMobileCountry] = useState({
    id: 118,
    iso: "IN",
    name: "INDIA",
    nicename: "India",
    phonecode: 91,
    msisdnLength: 10
  });
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const dropdownRef = useRef(null);
  const [paginationData, setPaginationData] = useState({
    totalElements: 0,
    totalPages: 0
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCountryCodeList();
        console.log('Response:', JSON.stringify(response, null, 2));

        if (response?.countryList) {
          setCountryListData(response.countryList);
          // Find and set India as default for both dropdowns
          const india = response.countryList.find(
            (country) => country.iso === "IN"
          );
          if (india) {
            setMobileCountry(india); // Set default for mobile country
          }
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
        setCountryListData([]);
      }
    };
    fetchData();
  }, []);
  const getCountriesAndOperators = async () => {
    setLoaders((prev) => ({ ...prev, countryLoader: true }));
    try {
      const response = await GetCountries();
      if (response?.statusDescription?.status == 200) {
        setCountryList(response?.countryResponseList);
      } else {
        setCountryList([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountryList([]);
    }
    setLoaders((prev) => ({ ...prev, countryLoader: false }));
  };

  useEffect(() => {
    getCountriesAndOperators();
  }, []);

  // Reset operator when country changes
  useEffect(() => {
    setSelectedOperator(null);
  }, [selectedCountry]);

  const handleCountryChange = (e) => {
    const country = countryList.find((c) => c.countryName === e.target.value);
    setSelectedCountry(country);
  };

  const handleOperatorChange = (e) => {
    const operator = selectedCountry?.operatorList.find(
      (op) => op.operatorName === e.target.value
    );
    setSelectedOperator(operator);
  };

  // Add this helper function to calculate the actual input length needed
  const getRequiredLength = () => {
    if (!selectedCountry?.msisdnLength || !selectedCountry?.msisdnPrefix) return 0;
    return selectedCountry.msisdnLength - selectedCountry.msisdnPrefix.length;
  };

  const handleUnauthorized = () => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Unauthorized access",
    });
    Navigate("/");
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        msisdn: selectedCountry.msisdnPrefix + phoneNumber, // Combine prefix with entered number
        pageNo: currentPage,
        pageSize: pageSize,
      };

      const response = await findDNDList(payload);
      if (response.statusDescription.status === 200) {
        // Map content and add actions separately
        const dndData = response.dndRegistryMsisdnList.content.map((item) => ({
          ...item,
          sno: currentPage * pageSize + 1,
          mobileNo: item.msisdn,
          actions: response.action // Use 'actions' instead of 'action' to match the pattern
        }));

        setDndList(dndData);
        setTableConfig({
          enabledColumns: response.enabledColumns,
          actions: response.action,
        });
        setPaginationData({
          totalElements: response.dndRegistryMsisdnList.page.totalElements,
          totalPages: response.dndRegistryMsisdnList.page.totalPages
        });
      } else if (response?.statusDescription?.status == 210) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.statusDescription?.description || "Failed to submit DND request",
        });
      } else if (response?.statusDescription?.status == 401) {
        handleUnauthorized();
      }
      else if (response?.statusDescription?.status == 400) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.statusDescription?.description || "Failed to submit DND request",
        });
      }
      else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.statusDescription?.description || "Failed to submit DND request",
        });
      }
    } catch (error) {
      console.error("Error submitting DND:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to submit DND request",
      });
    }
  };

  const handleTableAction = (action, rowData) => {
    switch (action.action) {
      case "View":
        setSelectedRowData(rowData);
        setViewDndModal(true);
        break;
      case "Delete":
        handleDelete(rowData);
        break;
      default:
        break;
    }
  };

  const handleDelete = (rowData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Want to delete this number? It won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const payload = {
            userId: getFromLocalStorage("userData")?.id,
            id: rowData.id,
          };

          const response = await DeleteDND(payload);
          if (response?.statusDescription?.status === 200) {
            Swal.fire(
              "Deleted!",
              response.statusDescription.description || "DND has been deleted.",
              "success"
            );
            // Refresh the DND list
            setDndList([]);
            setSelectedCountry(null);
            setSelectedOperator(null);
            setPhoneNumber("");
            // handleSubmit(new Event("submit"));
          } else {
            throw new Error(
              response?.statusDescription?.description || "Delete failed"
            );
          }
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error!", error.message || "Failed to delete DND", "error");
        }
      }
    });
  };

  // Add this useEffect for handling clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Add this helper function to render action buttons
  const renderActionButtons = (actions) => {
    return actions.map((action) => (
      <button
        key={action.id}
        className={`btn btn-link ${action.colorCode}`}
        title={action.titleName}
        onClick={() => handleTableAction(action)}
      >
        <i className={action.iconName}></i>
      </button>
    ));
  };

  console.log("cccccc", dndList);
  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="box">
              <div className="box-header">
                <div className="row">
                  <div className="col-md-8 col-12">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb breadcrumb_bg">
                        <li className="breadcrumb-item">
                          <a className="breadcrumb_1">
                            Setting & Configuration
                          </a>
                        </li>
                        <li
                          className="breadcrumb-item active breadcrumb_2 d-flex align-items-center"
                          aria-current="page"
                        >
                          <span>Manage DND(Block Subscription)</span>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-md-4 col-12 mt_3 d-flex align-items-center justify-content-end">
                    <div className="btn-group float-right">
                      <button
                        type="button"
                        className="btn btn-primary btn-raised btn-flat pull-right create_cp"
                        onClick={() => setAddNumberModal(true)}
                      >
                        Add Number
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-body">
                <form onSubmit={handleSubmit}>
                  <div className="card mt-4 position-relative">
                    <span class="mt-2 mb-3 fw-bold badge_head text-center">Manage DND</span>
                    <div className="row  mb-1  row_div pt-4 px-4">
                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                          <label>
                            Select Country<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={selectedCountry?.countryName || ""}
                            onChange={handleCountryChange}
                            required
                          >
                            <option value="">Select Country</option>
                            {countryList.map((country) => (
                              <option
                                key={country.id}
                                value={country.countryName}
                              >
                                {country.countryName}
                              </option>
                            ))}
                          </select>
                        {/* </div> */}
                      </div>

                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                          <label>
                            Select Operator<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={selectedOperator?.operatorName || ""}
                            onChange={handleOperatorChange}
                            required
                            disabled={!selectedCountry}
                          >
                            <option value="">Select Operator</option>
                            {selectedCountry?.operatorList.map((operator) => (
                              <option
                                key={operator.id}
                                value={operator.operatorName}
                              >
                                {operator.operatorName}
                              </option>
                            ))}
                          </select>
                        {/* </div> */}
                      </div>

                      {selectedOperator && (
                        <div className="form-group col-sm-4 mobdiv_config">
                          {/* <div className="form-group"> */}
                            <label className="font-weight-bold">
                              Mobile Number<span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              {selectedCountry && selectedCountry.msisdnPrefix && (
                                <span className="input-group-text">+{selectedCountry.msisdnPrefix}</span>
                              )}
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Mobile Number"
                                value={phoneNumber}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, "");
                                  const maxLength = getRequiredLength();
                                  if (maxLength && value.length <= maxLength) {
                                    setPhoneNumber(value);
                                  }
                                }}
                                maxLength={getRequiredLength()}
                                required
                                disabled={!selectedCountry}
                              />
                            </div>
                            {/* {selectedCountry?.msisdnLength && (
                            <small className="form-text text-muted">
                              Enter {getRequiredLength()} digits after +{selectedCountry.msisdnPrefix}
                            </small>
                          )} */}
                          {/* </div> */}
                        </div>
                      )}

                      <div className="form-group col-md-2 text-right my-4  buttons_divs">
                        {/* <div className="form-group"> */}
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={
                              !selectedCountry ||
                              !selectedOperator ||
                              !phoneNumber
                            }
                          >
                            Submit
                          </button>
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </form>

                {/* Add the ViewDND component */}
                <ViewDND
                  show={viewDndModal}
                  onHide={() => {
                    setViewDndModal(false);
                    setSelectedRowData(null);
                  }}
                  dndData={selectedRowData}
                />

                {/* Add the table section */}
                {dndList.length > 0 && (
                  <div className="card mt-4 p-3">
                    <div className="dnd-table-container">
                      <div className="form-group d-flex align-items-center justify-content-between gap-2 records">
                        <div className="d-flex">
                          <span>Show</span>
                          <select
                            className="form-select count_select mx-2"
                            value={pageSize}
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                              setCurrentPage(0);
                              handleSubmit(new Event('submit'));
                            }}
                            style={{ width: "auto" }}
                          >
                            {[10, 25, 50, 100].map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                          <span>entries</span>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary ref_but"
                            onClick={() => handleSubmit(new Event('submit'))}
                          >
                            Refresh &nbsp;
                            <i className="fas fa-sync ms-auto"></i>
                          </button>
                        </div>
                      </div>
                      <div id="table">
                        <CustomTable
                          data={dndList}
                          enabledColumns={tableConfig.enabledColumns}
                          actions={tableConfig.actions}
                          onAction={handleTableAction}
                          currentPage={currentPage}
                          pageSize={pageSize}
                          onPageChange={(page) => setCurrentPage(page)}
                          showPagination={true}
                          totalElements={paginationData.totalElements}
                          totalPages={paginationData.totalPages}
                          renderAction={(row) => renderActionButtons(row.actions)}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <AddDndModal
        show={addNumberModal}
        onHide={() => setAddNumberModal(false)}
        countryList={countryList}
        onSuccess={() => {
          getCountriesAndOperators();
          setAddNumberModal(false);
        }}
      />
    </div>
  );
};

export default ManageDnd;
